import React, { useState } from 'react';
import PropTypes from 'prop-types';

const CollapsableBlockMobile = props => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleBlockOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="m-profile-block">
      <div className="m-collapsable-block-header" onClick={toggleBlockOpen}>
        <p>{props.header}</p>
        {!isOpen && <img src="img/icons/caret-down.svg" />}
        {isOpen && <img src="img/icons/caret-up.svg" />}
      </div>
      {isOpen && <div className="py-15px">{props.children}</div>}
    </div>
  );
};

CollapsableBlockMobile.propTypes = {
  header: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default CollapsableBlockMobile;
